export default "__VITE_ASSET__Dmq0FeJi__"